import * as React from "react";
const SvgArrowLeftSFill = props => <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" {...props}><path d="m8 12 6-6v12z" /></svg>;
export default SvgArrowLeftSFill;